/**
 * PwaInstallRewardMount — invisible component that wires the install-reward
 * hook to the app lifecycle. Mounted once inside the AuthProvider so the
 * hook has access to the current user.
 */
import { usePwaInstallReward } from "@/hooks/usePwaInstallReward";

export function PwaInstallRewardMount() {
  usePwaInstallReward();
  return null;
}
